import { create } from 'zustand';

type IndicatorState = {
  isVisible: boolean;
  message?: string;
  subMessage?: string;
  waitForAnimationCycle?: boolean;
  showIndicator: (params?: {
    message?: string;
    subMessage?: string;
    waitForAnimationCycle?: boolean;
  }) => void;
  hideIndicator: () => void;
};

export const useIndicatorStore = create<IndicatorState>((set) => ({
  isVisible: false,
  message: undefined,
  subMessage: undefined,
  waitForAnimationCycle: false,
  showIndicator: ({ message, subMessage, waitForAnimationCycle } = {}) =>
    set({
      isVisible: true,
      message,
      subMessage,
      waitForAnimationCycle,
    }),
  hideIndicator: () =>
    set({
      isVisible: false,
      message: undefined,
      subMessage: undefined,
      waitForAnimationCycle: false,
    }),
}));
